<template>
    <div class="new-product-form">
      <p class="title">{{editItem ? 'Edit' : 'Add New'}}</p>
        <form v-on:submit.prevent="editSetting">
            <div class="label required">Product</div>
            <div class="input-ctn">
                <input type="text" v-model="productLabel" placeholder="Product" onkeydown="event.preventDefault()" class="input" @focus="openLocalProductModal">
            </div>

            <div class="label required">Origin Price($)</div>
            <div class="input-ctn">
                <input type="number" min="0" step="0.01" v-model="originPrice" placeholder="Origin Price" class="input"
                    oninput="validity.valid||(value='');">
            </div>

            <div class="label required">Promotion Price($)</div>
            <div class="input-ctn">
                <input type="number" min="0" step="0.01" v-model="promotionPrice" placeholder="Promotion Price"
                    class="input" oninput="validity.valid||(value='');">
            </div>
            <div class="label required">Promotion Percentage(%)</div>
            <div class="input-ctn">
                <input type="number" min="0" v-model="promotionPercentage" placeholder="Promotion Percentage"
                    class="input" oninput="validity.valid||(value='');">
                <input type="color" v-model="promotionPercentageColor" class="input">
            </div>

            <div class="label">Order</div>
            <div class="input-ctn">
                <input type="number" min="0" v-model="order" placeholder="Order" class="input"
                    oninput="validity.valid||(value='');">
            </div>

            <button class="btn submit">Save</button>
        </form>
        <SelectLocalProductModal
            :closeModal="closeLocalProductModal"
            v-show="productModalOpened"
            :onSubmit="selectedProduct"
        />
    </div>
  </template>
  
  <script>
    import SelectLocalProductModal from "../../components/SelectLocalProductModal";
    
    export default {
        name: "NewProduct",
        components: {
            SelectLocalProductModal
        },
        props: ['addNewSuccess', 'editItem'],
        data() {
            return {
                id: this.editItem?._id,
                productId: this.editItem?.product?._id,
                productLabel: this.editItem?.product?.name,
                originPrice: this.editItem?.originPrice || 0,
                promotionPrice: this.editItem?.promotionPrice || 0,
                promotionPercentage: this.editItem?.promotionPercentage || 0,
                promotionPercentageColor: this.editItem?.promotionPercentageColor || "#ff4200",
                order: this.editItem?.order || 20,
                isLoading: true,
                productModalOpened: false,
            }
        },
        methods: {
            async editSetting() {
                if(!this.productId && !this.product) {
                    alert('Please select product');
                    return;
                }
                this.isLoading = true

                const success = await this.$store.dispatch(this.id ? 'updateSettingPromotionLocalProduct' :
                    'createSettingPromotionLocalProduct', {
                        _id: this.id,
                        productId: this.product?._id || this.editItem?.product?._id,
                        productName: this.product?.name || this.editItem?.product?.name,
                        originPrice: this.originPrice,
                        promotionPrice: this.promotionPrice,
                        promotionPercentage: this.promotionPercentage,
                        promotionPercentageColor: this.promotionPercentageColor,
                        order: this.order
                    })
                if (success) {
                    alert("Successfully");
                    this.addNewSuccess();
                }
                this.isLoading = false
            },
            openLocalProductModal() {
                this.productModalOpened = true;
                setTimeout(() => {
                    document.getElementById("selectProductModelSearchInput").focus();
                })
            },
            closeLocalProductModal() {
                this.productModalOpened = false;
            },
            selectedProduct(product) {
                if(this.product == product) {
                    return;
                }

                if(product) {
                    this.productLabel = product.name;
                } else {
                    this.productLabel = null;
                }
                this.product = product;
            },
        }

    }
  </script>
  
  <style>
  
  </style>